const joinCut = (method) => {
  return (_target, _propertyKey, descriptor) => {
    const next = descriptor.value ?? (() => undefined);

    Object.assign(descriptor, {
      value(this) {
        setImmediate(() => this[method]?.());
        return Reflect.apply(next, this, arguments);
      },
    });
  };
};

export default joinCut;
